import React, { useState } from "react";
import { User, Receipt, WalletMinimal, LockKeyhole, MessageCircle, BookOpenText, X } from "lucide-react";

const navigationItems = [
  {
    id: "profile",
    label: "Profile",
    icon: User,
    description: "View and edit your profile",
    iconClass: "icon-profile",
  },
  {
    id: "subscription",
    label: "Manage Subscription",
    icon: Receipt,
    description: "View and manage your subscription",
    iconClass: "icon-manage-subscription",
  },
  {
    id: "wallet",
    label: "Wallet",
    icon: WalletMinimal,
    description: "View your wallet and cards",
    iconClass: "icon-wallet",
  },
  {
    id: "password",
    label: "Change Password",
    icon: LockKeyhole,
    description: "Update your password",
    iconClass: "icon-change-password",
  },
  {
    id: "support",
    label: "Help & Support",
    icon: MessageCircle,
    description: "Get help and support",
    iconClass: "icon-help-support",
  },
  {
    id: "data",
    label: "Privacy Policy",
    icon: BookOpenText,
    description: "Read our privacy policy",
    iconClass: "icon-privacy-policy",
  },
];

const MobileNavDrawer = ({ setOpenDrawer, setTab }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleItemClick = (item) => {
    console.log("Navigate to:", item.id);
    setTab(item.id);
    closeDrawer();
  };

  const closeDrawer = () => setOpenDrawer(false);
  return (
    <>
      {/* Trigger Button */}
      {/* <div onClick={openDrawer} style={{ cursor: "pointer" }}>
        {trigger}
      </div> */}

      {/* Overlay */}
      {isOpen && <div className='drawer-overlay' onClick={closeDrawer} />}

      {/* Drawer Content */}
      <div className={`drawer-container ${isOpen ? "drawer-open" : "drawer-closed"}`}>
        {/* Header */}
        <div className='drawer-header'>
          <h2 className='drawer-title'>Menu</h2>
          <button className='drawer-close-btn' onClick={closeDrawer}>
            <X size={20} />
          </button>
        </div>

        {/* Navigation List */}
        <div className='drawer-list'>
          {navigationItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <button key={item.id} onClick={() => handleItemClick(item)} className={`drawer-item ${item.iconClass}`}>
                <div className='drawer-item-icon'>
                  <IconComponent size={20} />
                </div>
                <div className='drawer-item-content'>
                  <div className='drawer-item-label'>{item.label}</div>
                  <div className='drawer-item-description'>{item.description}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MobileNavDrawer;
